/**
 * .subLink ドロップダウンの top をヘッダー下端に合わせる
 * .header-nav の下端位置を --header-height にセット
 */
(function() {
  var VAR_HEADER_HEIGHT = '--header-height';

  function updateHeaderHeight() {
    var nav = document.querySelector('.header-nav');
    if (!nav) return;
    var bottom = nav.getBoundingClientRect().bottom;
    document.documentElement.style.setProperty(VAR_HEADER_HEIGHT, bottom + 'px');
  }

  function init() {
    updateHeaderHeight();
    var items = document.querySelectorAll('.header-nav-list__item.is-subLink');
    for (var i = 0; i < items.length; i++) {
      items[i].addEventListener('mouseenter', updateHeaderHeight);
    }
    window.addEventListener('resize', updateHeaderHeight);
    window.addEventListener('scroll', updateHeaderHeight, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
